export default __webpack_public_path__ + "static/media/mprojectfeature1.33b646c9.png";